module.exports = __webpack_public_path__ + "img/exclamation-warning.2d1568da.png";